// Non sono un problema i check nella regex perché da standard sono ammessi solo i seguenti caratteri:
// RFC 4648

import { parseDataReference } from '../../../../schema/expressions/compute/input/nodes/ComputeExpressionReferenceNode.tsx';
import { type IReference } from '../../../../schema/expressions/references/IReference.ts';

// ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/  (e = come padding)
export const COMPUTE_REFERENCE_TAG_REGEX =
  /<span (data-type|class)="compute-expression-reference" [^>]* data-reference="([a-zA-Z0-9+/=]+)">@([^<]+)<\/span>/g;

export type ReplaceRichTextReferenceFn = (
  reference: IReference,
  encoded: string,
  match: string,
) => string;

export interface IReplaceRichTextReferencesOptions {
  /**
   * Se `true`, i tag con un `data-reference` non decodificabile restano
   * invariati invece di essere sostituiti con un placeholder
   * `missing-reference`. Da usare quando il testo risultante viene salvato
   * (es. migrazioni), per non alterare contenuti fuori scope.
   */
  keepInvalidReferences?: boolean;
}

/**
 * Sostituisce i riferimenti alle espressioni di calcolo con il valore
 * presente nel contesto di valutazione.
 */
export function replaceRichTextReferences(
  text: string | undefined | null,
  replacer: ReplaceRichTextReferenceFn,
  options: IReplaceRichTextReferencesOptions = {},
) {
  if (!text) return null;

  return text.replace(
    COMPUTE_REFERENCE_TAG_REGEX,
    (match, firstMatchedAttribute, encoded, code) => {
      const reference = parseDataReference(encoded);
      if (!reference) {
        return options.keepInvalidReferences
          ? match
          : `<span data-type="missing-reference" />`;
      }
      return replacer(reference, encoded, match);
    },
  );
}
